<template>
  <v-app>
    <Snackbar/>

    <v-navigation-drawer v-model="drawer" app>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">
            1v1me.gg
          </v-list-item-title>

          <v-list-item-subtitle>
            Prove you are the best
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list nav>
        <v-list-item link to="/">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/matches">
          <v-list-item-action>
            <v-icon>mdi-gamepad-variant</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>Matches</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <div class="pa-2" v-if="$store.state.user.uid">
          <v-btn block color="secondary" @click="logout">Logout</v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon class="hidden-lg-and-up" @click.stop="drawer = !drawer"/>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" to="/" icon>
            <v-icon>mdi-sword-cross</v-icon>
          </v-btn>
        </template>

        <span>Home</span>
      </v-tooltip>

      <v-spacer/>

      <v-btn class="hidden-xs-only" text to="/matches">
        Matches
      </v-btn>
      <div v-if="!$store.state.user.uid">
        <v-btn class="ma-1" to="/sign-in" tile outlined light>Sign In</v-btn>
        <v-btn class="ma-1" to="/sign-up" tile outlined>Sign Up</v-btn>
      </div>
    </v-app-bar>

    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import Snackbar from '@/components/Snackbar.vue';

export default {
  name: 'App',
  data: () => ({
    drawer: null
  }),
  components: {
    Snackbar
  },
  methods: {
    logout() {
      if(this.$vuetify.breakpoint.mdAndDown) {
        this.drawer = false;
      }

      this.$store.dispatch('logout');
    }
  }
};
</script>
